import { apiService } from '../general/APIService';
import * as InputTransformer from '../../transformers/input/rect-silencer';

const CALCULATION_ENDPOINT = '/calculations/rect-silencer-options';

export async function calculateOptions(data) {
    const response = await apiService.post(CALCULATION_ENDPOINT, data);

    return InputTransformer.transformOptions(response.data.data);
}